import { makeStyles } from "@material-ui/styles"

export default makeStyles((theme) => ({
	box: {
		maxWidth: 104,
		minWidth: 104,
		maxHeight: 38,
	},
	form: {
		"&:hover .input-label-searches": {
			color: `${theme.palette.primary.contrastText}`,
		},
		"& .input-label-searches.Mui-focused": {
			color: `${theme.palette.primary.contrastText}`,
		},

		"&:hover .MuiInputBase-root .MuiSvgIcon-root": {
			color: `${theme.palette.primary.contrastText}`,
		},
		"& .MuiInputBase-root.Mui-focused .MuiSvgIcon-root": {
			color: `${theme.palette.primary.contrastText}`,
		},
		"&.selected-icon-color .MuiInputBase-root .MuiSvgIcon-root": {
			color: `${theme.palette.primary.contrastText}`,
		},
		"& .MuiInputBase-root.MuiOutlinedInput-root.qa-review.Mui-focused": {
			background: theme.palette.primary.dark,
		},
	},
	reviewLabel: {
		color: theme.palette.primary.contrastText,
		width: 60,
		overflow: "hidden",
		textWrap: "nowrap",
		whiteSpace: "nowrap",
		textOverflow: "ellipsis",
		pointerEvents: "auto",
	},
	select: {
		"& .MuiSelect-root": {
			backgroundColor: theme.palette.primary.main,
		},
		"& .MuiSelect-root:hover": {
			backgroundColor: theme.palette.primary.dark,
		},
		"& .MuiSelect-select:focus": {
			background: "none",
		},
	},
	header: {
		position: "sticky",
		top: 0,
		zIndex: 2,
	},
	footer: {
		paddingLeft: 10,
		minHeight: 50,
		display: "flex",
		alignItems: "center",
	},
	card: {
		width: "100%",
	},
	search: {
		"& .MuiFilledInput-root": {
			background: theme.palette.grey[50],
		},
		"& .MuiInputBase-root": {
			borderBottom: `solid 1px ${theme.palette.grey[400]}`,
			height: 40,
		},
		"& .MuiInputBase-input": {
			boxShadow: "none",
			border: "none",
		},
		"& .MuiInputBase-input:focus": {
			boxShadow: "none",
			border: "none",
		},
	},
	searchIcon: {
		marginLeft: "10px",
	},
	list: {
		display: "flex",
		alignItems: "flex-start",
		justifyContent: "space-between",
		alignItems: "center",
		//borderBottom: `solid 1px ${theme.palette.grey[400]}`,
		paddingRight: "22px",
		minHeight: 40,
	},
	listScroll: {
		overflowY: "auto",
		maxHeight: 200,
		minHeight: 200,
	},
	addReview: {
		justifyContent: "flex-start",
		textTransform: "capitalize",
		color: theme.palette.primary.dark,
		"&:hover": {
			backgroundColor: "transparent",
		},
	},
	paper: {
		border: "1px solid",
		padding: theme.spacing(1),
		backgroundColor: theme.palette.background.paper,
	},
	createReview: {
		marginTop: 5,
		border: `1px solid ${theme.palette.grey[400]}`,
	},
	divider: {
		borderBottom: `1px solid ${theme.palette.grey[400]}`,
	},
	listTitle: {
		color: theme.palette.text.primary,
		backgroundColor: theme.palette.grey.D600,
		fontWeight: 500,
		fontSize: 16,
		padding: "6px 22px 6px 16px",
	},
	listItem: {
		fontWeight: 400,
		fontSize: 16,
		color: theme.palette.text.primary,
	},
}))
